<template>
  <div class="section-legal">
    <h1>{{ $t("legal.title") }}</h1>
    <div class="content">
      <p v-html="$t('legal.1')"></p>
      <p v-html="$t('legal.2')"></p>
      <p v-html="$t('legal.3')"></p>
      <p v-html="$t('legal.4')"></p>
      <p v-html="$t('legal.5')"></p>
      <p v-html="$t('legal.6')"></p>
      <p v-html="$t('legal.7')"></p>
      
      <h4 v-html="$t('legal.8')"></h4>
      
      <h5 v-html="$t('legal.9')"></h5>
      <p v-html="$t('legal.10')"></p>
      <p v-html="$t('legal.11')"></p>
      <p v-html="$t('legal.12')"></p>
      
      <h5 v-html="$t('legal.13')"></h5>
      <p v-html="$t('legal.14')"></p>
      <p v-html="$t('legal.15')"></p>

      <h5 v-html="$t('legal.16')"></h5>
      <p v-html="$t('legal.17')"></p>
      <p v-html="$t('legal.18')"></p>
      
      <h5 v-html="$t('legal.19')"></h5>
      <p v-html="$t('legal.20')"></p>
      <p v-html="$t('legal.21')"></p>
      <p v-html="$t('legal.22')"></p>

      <h5 v-html="$t('legal.23')"></h5>
      <p v-html="$t('legal.24')"></p>

      <h5 v-html="$t('legal.25')"></h5>
      <h6 v-html="$t('legal.26')"></h6>
      <p v-html="$t('legal.27')"></p>
      <h6 v-html="$t('legal.28')"></h6>
      <p v-html="$t('legal.29')"></p>
      <h6 v-html="$t('legal.30')"></h6>
      <p v-html="$t('legal.31')"></p>
      <p v-html="$t('legal.32')"></p>
      <h6 v-html="$t('legal.33')"></h6>
      <p v-html="$t('legal.34')"></p>
      <p v-html="$t('legal.35')"></p>
      <h6 v-html="$t('legal.36')"></h6>
      <p v-html="$t('legal.37')"></p>
      <p v-html="$t('legal.38')"></p>
      <p v-html="$t('legal.39')"></p>
      <p v-html="$t('legal.40')"></p>
      <h6 v-html="$t('legal.41')"></h6>
      <p v-html="$t('legal.42')"></p>
      <p v-html="$t('legal.43')"></p>
      <p v-html="$t('legal.44')"></p>
      <p v-html="$t('legal.45')"></p>

      <h6 id="remove-user" v-html="$t('legal.remove.user.title')"></h6>
      <br/>
      <ul style="list-style:disc; margin-left:30px;">
        <li v-html="$t('legal.remove.user.content.1')"></li>
        <li v-html="$t('legal.remove.user.content.2')"></li>
      </ul>
      <br/>
      <p v-html="$t('legal.remove.user.content.3')"></p>

      <h6 id="clarity" v-html="$t('legal.clarity.title')"></h6>
      <p v-html="$t('legal.clarity.1')"></p>
      <p v-html="$t('legal.clarity.2')"></p>
      <p v-html="$t('legal.clarity.3')"></p>
      <p v-html="$t('legal.clarity.4')"></p>

      <h5 v-html="$t('legal.46')"></h5>
      <p v-html="$t('legal.47')"></p>

      <h5 v-html="$t('legal.48')"></h5>
      <p v-html="$t('legal.49')"></p>
      <p v-html="$t('legal.50')"></p>

      <h5 v-html="$t('legal.51')"></h5>
      <p v-html="$t('legal.52')"></p>

      
      <h5 v-html="$t('legal.53')"></h5>
      <p v-html="$t('legal.54')"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'component-legal',

  data() {
    return {

    }
  },

  props: {
    
  },

 
  mounted() {
    if(window.location.hash.includes('#remove-user')){
      let top = document.querySelector(`#remove-user`).offsetTop
      document.querySelector(`.main-content`).scrollTo({ top: top, left: 0, behavior: 'smooth' })
    }
  },

  computed: {
    

  },

  methods: {
    
  },
  watch: {

  }
}
</script>
